/* @flow */
import React from 'react';

import BoxBody from 'components/BoxBody.jsx';
import CurrentUser from 'auth/CurrentUser';
import Dialog from 'components/Dialog.jsx';
import SignInForm from 'auth/components/SignInForm.jsx';

const SignInModal = React.createClass({
  propTypes: {
    email: React.PropTypes.string,
    onRequestHide: React.PropTypes.func,
    onSignedIn: React.PropTypes.func,
  },

  getDefaultProps() {
    return {
      email: '',
      onSignedIn: () => {},
      onRequestHide: () => {},
    };
  },

  componentDidMount() {
    CurrentUser.addSignInListener(this.onSignedIn);
    CurrentUser.addSignInNoRoleListener(this.onSignedIn);
  },

  componentWillUnmount() {
    CurrentUser.removeSignInListener(this.onSignedIn);
    CurrentUser.removeSignInNoRoleListener(this.onSignedIn);
  },

  onSignedIn() {
    // $FlowIssue
    this.props.onSignedIn();
    // $FlowIssue
    this.props.onRequestHide();
  },

  render() {
    return (
      <Dialog
        eventScreenName="SignInModal"
        {...this.props}
        size="small"
        className="SignInModal">
        <BoxBody>
          <SignInForm uid={this.props.email} />
        </BoxBody>
      </Dialog>
    );
  },
});

export default SignInModal;



// WEBPACK FOOTER //
// ./src/auth/components/SignInModal.jsx